// consumableTrackerTypes.js
// Maps tracker type numbers to user-friendly Danish names

export const CONSUMABLE_TRACKER_TYPE_LABELS = {
  1: 'Allergimedicin (antihistamin mv)',
  2: 'Næsespray',
  3: 'Øjendråber',
  4: 'Astmaspray/inhalator akut',
  5: 'Astmaspray/inhalator forebyggende',
  6: 'Eksembehandling',
};
